import {
  Description,
  ImageContainer,
  StepContainer,
  Title,
} from 'Components/SharedComponents/Surveys/Surveys.styled'
import {
  ActionElementType,
  changeLevels,
} from 'Components/SharedComponents/Surveys/constants'
import { NextActions } from 'Components/SharedComponents/Surveys/NextActions/NextActions'
import { UserActions } from 'Components/SharedComponents/Surveys/UserActions/UserActions'
import {
  ButtonAction,
  CustomAction,
} from 'Components/SharedComponents/Surveys/types'
import { HandleActionArgs } from '../types'
import { CheckInWizardStep } from '../constants'
import { CheckInSurveyStepper } from './CheckInSurveyStepper'

type YourOrgMissionImpactProps = {
  onAnyAction: ({ nextStep, callback }: HandleActionArgs) => void
  orgMissionChange: string
  orgMissionChangeExplanation: string
  onSetOrgMissionChange: (change: string) => void
  onSetOrgMissionChangeExplanation: (explanation: string) => void
}

export const YourOrgMissionImpact = ({
  onAnyAction,
  orgMissionChange,
  orgMissionChangeExplanation,
  onSetOrgMissionChange,
  onSetOrgMissionChangeExplanation,
}: YourOrgMissionImpactProps) => {
  const nextActions: ButtonAction[] = [
    {
      disabled: orgMissionChange === '',
      label: 'Next',
      path: CheckInWizardStep.YOUR_ORG_HEALTH,
      saveUserState: true,
      type: ActionElementType.BUTTON,
    },
  ]

  const userActions: CustomAction[] = [
    {
      callback: (...args: unknown[]) =>
        onSetOrgMissionChange(args[0] as string),
      label:
        'How has your organization’s progress toward achieving its mission changed?',
      options: changeLevels,
      required: true,
      type: ActionElementType.SELECT,
      value: orgMissionChange,
    },
    {
      callback: (...args: unknown[]) =>
        onSetOrgMissionChangeExplanation(args[0] as string),
      label: 'Please explain your choice',
      type: ActionElementType.TEXT_FIELD,
      value: orgMissionChangeExplanation,
    },
  ]

  return (
    <StepContainer>
      <CheckInSurveyStepper step={1} />
      <Title>About your organization&apos;s mission impact</Title>
      <Description>
        Last time we asked you and other leaders in your organization to rate
        their confidence level when thinking about achieving your org&apos;s
        mission.
      </Description>
      <ImageContainer>{/* <Image src={getStarted} /> */}</ImageContainer>
      <UserActions onAnyAction={onAnyAction} userActions={userActions} />
      <NextActions nextActions={nextActions} onAnyAction={onAnyAction} />
    </StepContainer>
  )
}
